module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBoldItalic.261dc63b.ttf";